import React from "react";
import {FactorsUIProvider} from "./FactorsUIContext";
import FactorsListCmp from "./FactorsListCmp";

export default function Factors() {
    return (
        <FactorsUIProvider>
            <FactorsListCmp/>
        </FactorsUIProvider>
    )
}